import React from "react";
import { Outlet } from "react-router-dom";
import Footer from "./Footer";

/**
 * Layout pour les pages d'authentification
 */
const AuthLayout = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen bg-gradient-to-br from-green-50 to-emerald-100">
      <main className="flex-grow py-8">{children || <Outlet />}</main>

      <Footer />
    </div>
  );
};

export default AuthLayout;
